import { AppAvatar, NoteDirection } from "@/shared/Components";
import { AppCheckbox } from "@/shared/Components/AppCheckbox";
import { handleFullName } from "@/shared/utils/handle-contacts-null";
import type { FC } from "react";
import type { NotesTableItem } from "@/features/NotesManager/model";
import styles from "./styles.module.scss";

type DeleteNoteItemProps = {
  note: NotesTableItem;
  checked: boolean;
  toggleCheckbox: (id: string) => void;
};

export const DeleteNoteItem: FC<DeleteNoteItemProps> = ({ note, checked, toggleCheckbox }) => {
  const { person } = note;

  const personName = handleFullName(person?.firstName, person?.lastName, person?.middleName);
  const handleChange = () => {
    toggleCheckbox(note.id);
  };
  return (
    <div className={styles.root}>
      <AppCheckbox checked={checked} onChange={handleChange} />
      <div className={styles.person}>
        <div className={styles["note-direction"]}>
          <NoteDirection direction={note.direction} />
        </div>
        <div className={styles.avatar}>
          <AppAvatar name={personName} image={""} />
        </div>
        <div className={styles["person-info"]}>
          <div className={styles["person-title"]}>{person?.title}</div>
          <div className={styles["person-name"]}>{personName}</div>
        </div>
        <div className={styles["note-title"]}>{note.title}</div>
      </div>
    </div>
  );
};
